import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { KeyValUnderline } from "../../../../../libraries/ReportGenerator/KeyValUnderline";
import ReportFraInfoSectionContainer from "../../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportTitleSection from "../../../../../libraries/ReportGenerator/ReportTitleSection";
import { themeService } from "../../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../../sims/style";
import { ReportGroupingUtils } from "../../../utils/reportGroupingUtils";

import React from "react";
import { ST_1_DigiCodeTrackCircuit_Schema } from "./ST-1_DigiCodeTrackCircuit_Schema";
import { EqualContentsRow } from "../../../../../libraries/ReportGenerator/EqualContentsRow";
import AssetAreaCondition from "../../AssetAreaConditionReport";

const ST_1_DigiCodeTrackCircuit_Report = (props) => {
  const { reportData } = props;
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    "PATH_ST1DigicodeTrackCircuit",
    "PATH_AssetAreaCondition",
  ]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);

  return decodedReports.map((report, i) => <ViewReport key={i} data={report} {...props} />);
};
const ViewReport = (props) => {
  const { data } = props;
  const { decodedData } = data;
  let tourfound = decodedData.find((e) => (e.otherInfo || {}).tours);
  let tours = tourfound && tourfound.otherInfo.tours;
  let tour = tours && tours[0];
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");
  let showReport = assetAreaConditionData.length !== decodedData.length;
  return (
    showReport && (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection {...props} fontSizeOverride={"35px"} />
        <span className="spacer"></span>
        <ReportFraInfoSectionContainer
          {...props}
          data={{ ...data, tourNumber: (tour && tour.name) || (tour && tour.description) || " " }}
        />
        <span className="spacer"></span>
        <AssetAreaCondition data={assetAreaConditionData} />
        {decodedData
          .filter((t) => t.testCode !== "PATH_AssetAreaCondition")
          .map((singleReport, index) => (
            <div key={index}>
              <span className="spacer"></span>
              <table className="table-bordered">
                {ST_1_DigiCodeTrackCircuit_Schema.map((section, key) => (
                  <ReportTableSectionRenderer key={key} section={section} rowsData={singleReport.summary} />
                ))}
              </table>
            </div>
          ))}
      </div>
    )
  );
};

export default ST_1_DigiCodeTrackCircuit_Report;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/TrackCircuitReport/ST-1_DigiCodeTrackCircuit/index.jsx